import React from 'react'
import { Box, Typography } from '@mui/material'
import Logo from '../../Assets/Images/logo.svg'
import { styles } from './styles'

const MaintenancePage = () => {
  return (
    <Box sx={styles.root}>
      <Box
        component="img"
        src={Logo}
        alt="Logo"
        sx={styles.logo}
      />
      <Typography variant="h4" color="primary" sx={styles.heading}>
        We’ll be back soon!
      </Typography>
      <Typography variant="body1" color="textSecondary">
        Our site is currently under maintenance. Thank you for your patience.
      </Typography>
    </Box>
  )
}

export default MaintenancePage
